import { parseJSON, checkStatus } from '../../search-common/helpers'

// Constants.
export const ADD_FILTER_SPACE_TYPE = 'ADD_FILTER_SPACE_TYPE'
export const ADD_FILTER_AMENITY = 'ADD_FILTER_AMENITY'
export const ADD_AVAILABILITY_FILTER = 'ADD_AVAILABILITY_FILTER'
export const ADD_FLOOR_AREA_FILTER = 'ADD_FLOOR_AREA_FILTER'
export const ADD_ORDERBY_METHOD = 'ADD_ORDERBY_METHOD'
export const REMOVE_ORDERBY_METHOD = 'REMOVE_ORDERBY_METHOD'
export const REMOVE_FLOOR_AREA_FILTER = 'REMOVE_FLOOR_AREA_FILTER'
export const REMOVE_FILTER_SPACE_TYPE = 'REMOVE_FILTER_SPACE_TYPE'
export const REMOVE_AVAILABILITY_FILTER = 'REMOVE_AVAILABILITY_FILTER'
export const REMOVE_FILTER_AMENITY = 'REMOVE_FILTER_AMENITY'
export const REQUEST_SEARCH_RESULTS = 'REQUEST_SEARCH_RESULTS'
export const RECEIVE_SEARCH_RESULTS = 'RECEIVE_SEARCH_RESULTS'
export const FAILED_RECEIVE_SEARCH_RESULTS = 'FAILED_RECEIVE_SEARCH_RESULTS'
export const ADD_CITY_FILTER = 'ADD_CITY_FILTER'
export const REMOVE_CITY_FILTER = 'REMOVE_CITY_FILTER'
export const ADD_DISTRICT_FILTER = 'ADD_DISTRICT_FILTER'
export const REMOVE_DISTRICT_FILTER = 'REMOVE_DISTRICT_FILTER'
export const ADD_LOCATION_GROUP_FILTER = 'ADD_LOCATION_GROUP_FILTER'
export const REMOVE_LOCATION_GROUP_FILTER = 'REMOVE_LOCATION_GROUP_FILTER'
export const ADD_NEW_PROPERTY_FILTER = 'ADD_NEW_PROPERTY_FILTER'
export const REMOVE_NEW_PROPERTY_FILTER = 'REMOVE_NEW_PROPERTY_FILTER'
export const ADD_MOVEIN_FILTER = 'ADD_MOVEIN_FILTER'
export const REMOVE_MOVEIN_FILTER = 'REMOVE_MOVEIN_FILTER'
export const ADD_LOCATION_FILTER = 'ADD_LOCATION_FILTER'
export const REMOVE_LOCATION_FILTER = 'REMOVE_LOCATION_FILTER'
export const ADD_SEARCH_QUERY = 'ADD_SEARCH_QUERY'
export const REMOVE_SEARCH_QUERY = 'REMOVE_SEARCH_QUERY'
export const CHANGE_SEARCH_LOCATION = 'CHANGE_SEARCH_LOCATION'

/**
 * Function returns an action object for setting space
 * type filter to redux store.
 *
 * @param {string} spaceType
 * @return {object}
 */
export const addSpaceTypeFilter = ( spaceType ) => ({
  type: ADD_FILTER_SPACE_TYPE,
  data: spaceType
})

/**
 * Function returns an action object for setting custom
 * location group filter to redux store.
 *
 * @param {string} group
 * @return {object}
 */
export const addLocationGroupFilter = ( group ) => ({
  type: ADD_LOCATION_GROUP_FILTER,
  data: group
})

/**
 * Function returns an action object for removing custom
 * location group filter from redux store.
 *
 * @param {string} group
 * @return {object}
 */
export const removeLocationGroupFilter = ( group ) => ({
  type: REMOVE_LOCATION_GROUP_FILTER,
  data: group
})

/**
 * Function returns an action object for setting city
 * filter to redux store.
 *
 * @param {string} city
 */
export const addCityFilter = ( city ) => ({
  type: ADD_CITY_FILTER,
  data: city
})

/**
 * Function returns an action object for setting district
 * filter to redux store.
 *
 * @param {string} district
 */
export const addDistrictFilter = ( district ) => ({
  type: ADD_DISTRICT_FILTER,
  data: district
})

/**
 * Function returns an action object for setting location
 * filter to redux store.
 *
 * @param {string} location
 */
export const addLocationFilter = ( location ) => ({
  type: ADD_LOCATION_FILTER,
  data: location
})

/**
 * Function returns an action object for setting
 * search query to redux store.
 *
 * @param {object} query
 */
export const addSearchQuery = ( query ) => ({
  type: ADD_SEARCH_QUERY,
  data: query
})

/**
 * Function returns an action object for setting
 * search query to redux store.
 *
 * @param {object} query
 */
export const changeSearchLocation = ( query ) => ({
  type: CHANGE_SEARCH_LOCATION,
  data: query
})


/**
 * Function returns an action object to remove
 * search query from redux store.
 *
 */
export const removeSearchQuery = () => ({
  type: REMOVE_SEARCH_QUERY
})

/**
 * Function returns an action object to remove city
 * filter from redux store.
 *
 * @param {string} city
 */
export const removeCityFilter = ( city ) => ({
  type: REMOVE_CITY_FILTER,
  data: city
})

/**
 * Function returns an action object to remove district
 * filter from redux store.
 *
 * @param {string} district
 */
export const removeDistrictFilter = ( district ) => ({
  type: REMOVE_DISTRICT_FILTER,
  data: district
})

/**
 * Function returns an action object to remove location
 * filter from redux store.
 *
 */
export const removeLocationFilter = () => ({
  type: REMOVE_LOCATION_FILTER
})

/**
 * Function returns an action object for setting
 * amenity filter to redux store.
 *
 * @param {string} amenity
 * @return {object}
 */
export const addAmenityFilter = ( amenity ) => ({
  type: ADD_FILTER_AMENITY,
  data: amenity
})

/**
 * Function returns an action object for setting
 * the availability filter to redux store.
 *
 * @return {object}
 */
export const addAvailabilityFilter = () => ({
  type: ADD_AVAILABILITY_FILTER
})

/**
 * Function returns an action object for setting
 * the new property filter to redux store.
 *
 * @return {object}
 */
export const addNewPropertyFilter = () => ({
  type: ADD_NEW_PROPERTY_FILTER
})

/**
 * Function returns an action object for removing
 * the new property filter from redux store.
 *
 * @return {object}
 */
export const removeNewPropertyFilter = () => ({
  type: REMOVE_NEW_PROPERTY_FILTER
})

/**
 * Function returns an action object for setting
 * the Move In filter to redux store.
 *
 * @return {object}
 */
export const addMoveInFilter = () => ({
  type: ADD_MOVEIN_FILTER
})

/**
 * Function returns an action object for removing
 * the Move In filter from redux store.
 *
 * @return {object}
 */
export const removeMoveInFilter = () => ({
  type: REMOVE_MOVEIN_FILTER
})

/**
 * Function returns an action object for setting
 * the floor area filter to redux store.
 *
 * @param {object} area
 * @return {object}
 */
export const addFloorAreaFilter = ( area ) => ({
  type: ADD_FLOOR_AREA_FILTER,
  data: area
})

/**
 * Function returns an action object for setting
 * the query orderby value to redux store.
 *
 * @param {object} order
 * @return {object}
 */
export const addOrderByMethod = ( order ) => ({
  type: ADD_ORDERBY_METHOD,
  data: order
})

/**
 * Function returns an action object for removing
 * the query orderby value from redux store.
 *
 * @return {object}
 */
export const removeOrderByMethod = () => ({
  type: REMOVE_ORDERBY_METHOD
})

/**
 * Function returns an action object for removing
 * the floor areas filter from redux store.
 *
 * @return {object}
 */
export const removeFloorAreaFilter = () => ({
  type: REMOVE_FLOOR_AREA_FILTER
})

/**
 * Function returns an action object for removing
 * the availability filter from redux store.
 *
 * @return {object}
 */
export const removeAvailabilityFilter = () => ({
  type: REMOVE_AVAILABILITY_FILTER
})

/**
 * Function returns an action object for removing
 * the space type filter from redux store.
 *
 * @return {object}
 */
export const removeSpaceTypeFilter = () => ({
  type: REMOVE_FILTER_SPACE_TYPE
})

/**
 * Function returns an action object for removing
 * given amenity from redux stores amenities filter list.
 *
 * @param {string} amenity
 * @return {object}
 */
export const removeAmenityFilter = ( amenity ) => ({
  type: REMOVE_FILTER_AMENITY,
  data: amenity
})

/**
 * Function returns an action object which
 * declares the start of an search request.
 *
 * @return {object}
 */
const requestSearchResults = ( fetchPromise ) => ({
  type: REQUEST_SEARCH_RESULTS,
  data: fetchPromise
})

/**
 * Function returns an action object which
 * contains the results of the search request.
 *
 * @param {object} json
 * @return {object}
 */
export const receiveSearchResults = ( json ) => ({
  type: RECEIVE_SEARCH_RESULTS,
  data: json
})

/**
 * Function returns an action object which
 * contains the error object if the search
 * request failed.
 *
 * @param {object} error
 * @return {object}
 */
export const failedReceiveSearchResults = ( error ) => ({
  type: FAILED_RECEIVE_SEARCH_RESULTS,
  data: error
})

/**
 * Function starts fetching the search results
 * if there is no previous fetch going on.
 */
export const fetchSearchResultsIfNotBusy = () => {
  return ( dispatch, getState ) => {
    if ( shouldFetchSearchResults( getState())) {
      return dispatch( fetchSearchResults( getState, dispatch ))
    } else {
      return Promise.resolve( 'No need to fetch search results.' )
    }
  }
}

/**
 * Function checks if the search can be done
 * by checking if there is already ongoing search
 * request ongoing or not.
 *
 * @param {object} state
 */
const shouldFetchSearchResults = ( state ) => {
  if ( state.search.isFetching ) {
    return true
  }
  return true
}

/**
 * Sets url to match current search
 * @param {object} state
 */
const setUrl = ( state ) => {
  const prefix = state.locale === 'en' ? '/en/premises/' : '/toimitilat/'
  const spaceType = state.search.all_facets.space_types.find(( type ) => type.value === state.search.filters.space_type )
  const spaceTypeSlug = `${spaceType ? spaceType.slug : state.search.filters.space_type}/`
  const city = state.search.filters.cities.length > 0 ? `${state.search.filters.cities[0]}/` : ''
  const district = state.search.filters.districts.length > 0 ? `${state.search.filters.districts[0]}/` : ''
  const location = state.search.filters.location ? `?location=${state.search.filters.location}` : ''
  const query = state.search.query ? `?search=${state.search.query}` : ''
  const url = prefix + spaceTypeSlug + city + district + location + query
  history.replaceState({}, '', url )
}

/**
 * Function does the actual search fetch.
 * @param {object} state
 */
const fetchSearchResults = ( getState ) => {
  const state = getState()
  const url = `${window.location.origin}/wp-json/${state.searchUrl}/`

  setUrl( state )

  const payload = {
    locale: state.locale,
    orderby: state.search.orderby,
    filters: {
      space_type: state.search.filters.space_type,
      number_of_people: '',
      floor_area: state.search.filters.floor_area,
      amenities: state.search.filters.amenities,
      cities: state.search.filters.cities,
      districts: state.search.filters.districts,
      availability: state.search.filters.availability,
      new_property: state.search.filters.new_property,
      movein: state.search.filters.movein,
      location: state.search.filters.location
    },
    search: state.search.query
  }

  return ( dispatch ) => {
    dispatch( requestSearchResults( payload ))
    return fetch( url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify( payload )
      })
      .then( checkStatus )
      .then( parseJSON )
      .then(( json ) => {
        if ( getState().search.fetchPayload !== payload ) return
        dispatch( receiveSearchResults( json ))
      })
      .catch(( error ) => {
        dispatch( failedReceiveSearchResults( error ))
      })
  }
}
